import { Component, Inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { VALID_EMAIL } from '../../../../constants/general.constant';
import { IRegisterPopupModel } from '../../models/popup.model';
import { BasePopupComponent } from '../base-popup/base-popup.component';

@Component({
    selector: 'app-enter-info-popup',
    standalone: false,
    templateUrl: './enter-info-popup.component.html',
    styleUrl: './enter-info-popup.component.scss',
})
export class EnterInfoPopupComponent extends BasePopupComponent {
    protected infoForm = this.fb.group({
        displayName: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(VALID_EMAIL)]],
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IRegisterPopupModel,
        protected override dialogRef: MatDialogRef<EnterInfoPopupComponent>,
        private fb: NonNullableFormBuilder,
    ) {
        super(data, dialogRef);
    }

    static override getDialogConfig(): MatDialogConfig<IRegisterPopupModel> {
        return {
            data: { email: '', name: '' },
            backdropClass: 'blurred-backdrop',
        };
    }

    override ngOnInit(): void {
        super.ngOnInit();

        this.infoForm.patchValue({
            displayName: this.data.name,
            email: this.data.email,
        });
    }

    protected onSubmit(): void {
        this.infoForm.markAllAsTouched();
        if (this.infoForm.invalid) {
            return;
        }

        this.dialogRef.close(this.infoForm.value);
    }
}
